/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lens_Group_MineInputs */

const en_lens_group_mine = /** @type {(inputs: Lens_Group_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mine`)
};

/**
* | output |
* | --- |
* | "Mine" |
*
* @param {Lens_Group_MineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const lens_group_mine = /** @type {((inputs?: Lens_Group_MineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lens_Group_MineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_lens_group_mine(inputs)
});